const Home = () =>
    import("../components/home/home.vue");
const Patient = () =>
    import("../components/home/patient.vue");
const Clinic = () =>
    import("../components/home/clinic.vue");
const Professionals = () =>
    import("../components/home/professionals.vue");
const sectorPublic = () =>
    import("../components/home/sectorPublic.vue");
const insuranceCarrier = () =>
    import("../components/home/insurancecarrier.vue");
const Login = () =>
    import("../components/login/login.vue");
const Register = () =>
    import("../components/register/register.vue");
const Resert = () =>
    import("../components/login/resertpassword.vue");
const Recover = () =>
    import("../components/login/recoverPassword.vue");
const termsConditions = () =>
    import("../components/termsConditions/termsConditions.vue");
// const videoApp = () =>
//     import("../components/videoconsulta/videoConsultaApp.vue");
const emergencyCard = () =>
    import("../components/patient/emergency.vue");
const logout = () => import("../components/login/logout")

export default [{
    path: "/",
    name: "home",
    component: Home,
    props: {
        lang: "es"
    }
},
{
    path: "/home",
    name: "homeen",
    component: Home,
    props: {
        lang: "en"
    }
},
{
    path: "/paciente-en-control",
    name: "paciente-en-control",
    component: Patient,
    props: {
        lang: "es"
    }
},
{
    path: "/patient-in-control",
    name: "patient-in-control",
    component: Patient,
    props: {
        lang: "en"
    }
},
{
    path: "/tecnologia-digital-para-clinicas",
    name: "tecnologia-digital-para-clinicas",
    component: Clinic,
    props: {
        lang: "es"
    }
},
{
    path: "/digital-technology-for-clinics",
    name: "digital-technology-for-clinics",
    component: Clinic,
    props: {
        lang: "en"
    }
},
{
    path: "/medico-del-siglo-XXI",
    name: "medico-del-siglo-XXI",
    component: Professionals,
    props: {
        lang: "es"
    }
},
{
    path: "/medical-of-the-century-21s",
    name: "medical-of-the-century-21s",
    component: Professionals,
    props: {
        lang: "en"
    }
},
{
    path: "/salud-publica",
    name: "salud-publica",
    component: sectorPublic,
    props: {
        lang: "es"
    }
},
{
    path: "/public-health",
    name: "public-health",
    component: sectorPublic,
    props: {
        lang: "en"
    }
},
{
    path: "/innovacion-en-experiencia-del-cliente",
    name: "innovacion-en-experiencia-del-cliente",
    component: insuranceCarrier,
    props: {
        lang: "es"
    }
},
{
    path: "/innovation-in-customer-experience",
    name: "innovation-in-customer-experience",
    component: insuranceCarrier,
    props: {
        lang: "en"
    }
},
{
    path: "/iniciar-sesion",
    name: "logines",
    component: Login
},
{
    path: "/iniciar-sesion/iniciar-sesion",//solo temporal por error en template
    name: "logines",
    component: Login
},
{
    path: "/login",
    name: "loginen",
    component: Login
},
{
    path: "/register",
    name: "registeren",
    component: Register
},
{
    path: "/registrarme",
    name: "registeres",
    component: Register
},
{
    path: "/resert",
    name: "resertpassword",
    component: Resert
},
{
    path: "/recover",
    name: "recoverPassword",
    component: Recover
},
{
    path: "/terms",
    name: "termsConditions",
    component: termsConditions
},
// {
//     path: "/video",
//     name: "videoApp",
//     component: videoApp
// },
{
    path: "/emergency",
    name: "emergency",
    component: emergencyCard
},
{
    path: "/logout",
    name: "logout",
    component: logout
}
];



// WEBPACK FOOTER //
// ./src/router/home.js